// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HorizontalDivider_wrapper__ooViq","horizontal-divider":"HorizontalDivider_horizontal-divider__16_IK"};